import axios from "axios";
import {
  Branch_Contact_URL,
  Branch_Location_Pincode_URL,
  System_URL,
} from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const branchLocationActions = {
  FETCH_BRANCH_COUNT: "FETCH_BRANCH_COUNT",
  FETCH_BRANCH_COUNT_SUCCESS: "FETCH_BRANCH_COUNT_SUCCESS",
  FETCH_BRANCH_COUNT_ERROR: "FETCH_BRANCH_COUNT_ERROR",
};

export function GetBranchCountDetails(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Contact_URL}/get/getCountOfAllBranchByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchCountDetailsSuccess(response.data));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchCountDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchCountDetailsError(err));
          return err.response;
        }
      });
}
export function getBranchCountDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchLocationActions.FETCH_BRANCH_COUNT_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchCountDetailsError(error) {
  return {
    type: branchLocationActions.FETCH_BRANCH_COUNT_ERROR,
    payload: error,
  };
}
